import { render, staticRenderFns } from "./AssignProductPopup.vue?vue&type=template&id=2621669f"
import script from "./AssignProductPopup.vue?vue&type=script&lang=js"
export * from "./AssignProductPopup.vue?vue&type=script&lang=js"
import style0 from "./AssignProductPopup.vue?vue&type=style&index=0&id=2621669f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports